import type { GalleryItem } from '../types/content'

// Immagini fornite dalla proprietaria, a scopo di ispirazione:
// non sono lavori di allieve né prove di risultato.
export const creations: GalleryItem[] = [
  {
    id: 'nomi',
    motif: 'Nomi personalizzati',
    src: 'https://cdn.magicpatterns.com/uploads/s3CGL2uARcQLmjUpPHaMTs/nomi_personalizati.jpg',
    alt: 'Nome Laura in corsivo realizzato in tricotin rosa su un cerchio decorato con fiori in cordoncino e una farfalla',
  },
  {
    id: 'cameretta',
    motif: 'Decorazioni per la cameretta',
    src: 'https://cdn.magicpatterns.com/uploads/pEKr4ptWbQxYa6izMc8hmg/decorazioni_camaretta.jpg',
    alt: 'Giostrina sopra una culla bianca con sagome di animali e lettere in tricotin colorato',
  },
  {
    id: 'bomboniere',
    motif: 'Bomboniere',
    src: 'https://cdn.magicpatterns.com/uploads/82qnsauPEhpG48FxzqFqmj/bomboniere.jpg',
    alt: 'Cuori portafoto in tricotin rosa, uno dei quali regge la foto dei piedini di un neonato',
  },
  {
    id: 'portachiavi',
    motif: 'Portachiavi',
    src: 'https://cdn.magicpatterns.com/uploads/dL1DnsTU2pLUTAUtq2vCpr/portachiavi.jpg',
    alt: 'Portachiavi con lettera M in tricotin lilla e nappina, confezionati su cartoncini kraft',
  },
  {
    id: 'fiori',
    motif: 'Fiori',
    src: 'https://cdn.magicpatterns.com/uploads/g7vbsCpivBtmH4FyCLGev4/Fiori_di_cordoncino.jpg',
    alt: 'Tre fiori in tricotin giallo, corallo e rosa in un vasetto di vetro appoggiato su un libro',
  },
  {
    id: 'iniziali',
    motif: 'Iniziali decorative',
    src: 'https://cdn.magicpatterns.com/uploads/c2z6xxdW6EsstzapnsvKz3/Iniziali_decorative.jpg',
    alt: 'Lettera E in tricotin color sabbia decorata con fiori lilla e foglie verdi',
  },
]
